// @flow

import React from 'react';

import { CommonFiltersProvider } from '../../buisness/CommonFilters';

type Props = {
  children?: any,
};

export default ({ children }: Props) => (
  <CommonFiltersProvider>{children}</CommonFiltersProvider>
);
